export const TEMPLATE_META = {
  lead_welcome: { label: 'Welcome', text: 'text-violet-200', bg: 'bg-violet-500/30' },
  estimate_recap: { label: 'Estimate Recap', text: 'text-blue-200', bg: 'bg-blue-500/30' },
  unpaid_reminder: { label: 'Unpaid Nudge', text: 'text-amber-200', bg: 'bg-amber-500/30' },
  quiet_followup: { label: 'Follow-Up', text: 'text-violet-200', bg: 'bg-violet-500/30' },
  payment_receipt: { label: 'Deposit Receipt', text: 'text-emerald-200', bg: 'bg-emerald-500/30' },
  balance_receipt: { label: 'Balance Receipt', text: 'text-emerald-200', bg: 'bg-emerald-500/30' },
  contract_confirmed: { label: 'Contract Confirmed', text: 'text-cyan-200', bg: 'bg-cyan-500/30' },
  balance_due: { label: 'Balance Due', text: 'text-amber-200', bg: 'bg-amber-500/30' },
  event_prep: { label: 'Event Prep', text: 'text-orange-200', bg: 'bg-orange-500/30' },
  review_request: { label: 'Review Request', text: 'text-fuchsia-200', bg: 'bg-fuchsia-500/30' },
  daily_digest: { label: 'Owner Daily Brief', text: 'text-blue-200', bg: 'bg-blue-500/30' },
  custom: { label: 'Custom Text', text: 'text-zinc-100', bg: 'bg-white/20' },
};

export const tplMeta = (key) => TEMPLATE_META[key] || { label: key || 'Text', text: 'text-zinc-200', bg: 'bg-white/15' };

// Activity type colors: calls are BLUE, outbound texts are EMERALD, inbound DMs colored by channel
export const TYPE_ICON_CLS = {
  call: 'bg-blue-500/25 text-blue-300',
  text: 'bg-emerald-500/25 text-emerald-300',
  inbound: 'bg-fuchsia-500/25 text-fuchsia-300',
  inquiry: 'bg-violet-500/25 text-violet-300',
};

export const CHANNEL_META = {
  instagram: { label: 'Instagram', text: 'text-fuchsia-200', bg: 'bg-fuchsia-500/30' },
  facebook: { label: 'Facebook', text: 'text-blue-200', bg: 'bg-blue-500/30' },
  messenger: { label: 'Messenger', text: 'text-blue-200', bg: 'bg-blue-500/30' },
  whatsapp: { label: 'WhatsApp', text: 'text-emerald-200', bg: 'bg-emerald-500/30' },
  email: { label: 'Email', text: 'text-violet-200', bg: 'bg-violet-500/30' },
  sms: { label: 'SMS', text: 'text-emerald-200', bg: 'bg-emerald-500/30' },
};
export const chMeta = (ch) => CHANNEL_META[ch] || { label: ch || 'Message', text: 'text-fuchsia-200', bg: 'bg-fuchsia-500/30' };

// Priority kinds on the Today screen — vivid neon pills
export const KIND_META = {
  respond: { label: 'Needs Response', text: 'text-violet-200', bg: 'bg-violet-500/30' },
  unpaid: { label: 'Unpaid', text: 'text-amber-200', bg: 'bg-amber-500/30' },
  balance: { label: 'Balance Due', text: 'text-orange-200', bg: 'bg-orange-500/30' },
  unsigned: { label: 'Contract', text: 'text-cyan-200', bg: 'bg-cyan-500/30' },
  vendor_stalled: { label: 'Vendor Silent', text: 'text-rose-200', bg: 'bg-rose-500/30' },
};
